module.exports = __webpack_public_path__ + "img/y22.20d6dc37.jpg";